// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo_logo__F9E50 {
  display: flex;
  align-items: center;
  gap: 1.4rem;
  font-family: "Montserrat Alternates";
  font-size: 2.6rem;
  line-height: normal;
}
.Logo_logo__F9E50 .Logo_icon__8T3zT {
  padding: 0.8rem;
  display: flex;
  align-items: center;
  border-radius: 100%;
  border: 1px solid #edf1ce;
  box-shadow: 0px 0px 8.4px 0px #00a4f4;
}
.Logo_logo__F9E50 .Logo_icon__8T3zT > svg {
  width: 4rem;
  height: 4rem;
}

@media (max-width: 800px) {
  .Logo_logo__F9E50 {
    gap: 1rem;
    font-size: 2rem;
  }
  .Logo_logo__F9E50 .Logo_icon__8T3zT {
    padding: 0.5rem;
  }
  .Logo_logo__F9E50 .Logo_icon__8T3zT > svg {
    width: 2.8rem;
    height: 2.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Logo/Logo.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,oCAAA;EACA,iBAAA;EACA,mBAAA;AAAD;AAEC;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qCAAA;AAAF;AACE;EACC,WAAA;EACA,YAAA;AACH;;AAIA;EACC;IACC,SAAA;IACA,eAAA;EADA;EAGA;IACC,eAAA;EADD;EAGC;IACC,aAAA;IACA,cAAA;EADF;AACF","sourcesContent":[".logo {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1.4rem;\n\t// color: var(--white);\n\tfont-family: 'Montserrat Alternates';\n\tfont-size: 2.6rem;\n\tline-height: normal;\n\n\t.icon {\n\t\tpadding: 0.8rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder-radius: 100%;\n\t\tborder: 1px solid #edf1ce;\n\t\tbox-shadow: 0px 0px 8.4px 0px #00a4f4;\n\t\t& > svg {\n\t\t\twidth: 4rem;\n\t\t\theight: 4rem;\n\t\t}\n\t}\n}\n\n@media (max-width: 800px) {\n\t.logo {\n\t\tgap: 1rem;\n\t\tfont-size: 2rem;\n\n\t\t.icon {\n\t\t\tpadding: 0.5rem;\n\n\t\t\t& > svg {\n\t\t\t\twidth: 2.8rem;\n\t\t\t\theight: 2.8rem;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `Logo_logo__F9E50`,
	"icon": `Logo_icon__8T3zT`
};
export default ___CSS_LOADER_EXPORT___;
